import ActionTypes from "../constants/action_types";

export default function clearOrganisation() {
  return {
    type: ActionTypes.ORGANISATION_CLEAR.SUCCESS,
  };
}
